import slice from 'lodash/slice';
export const _slice = slice;
